function getInternalKeyForLocationDescriptor(descriptor) {
  switch (descriptor?.type) {
    case "course":
      return `${descriptor.courseId}-${descriptor.chapterId}-${descriptor.revisionId}`;
    case "page":
      return descriptor.pageId;
    default:
      return "";
  }
}

export { getInternalKeyForLocationDescriptor };
//# sourceMappingURL=util.get-internal-key.js.map
